<section class="whyus-section" id="why-us">
  <div class="atw-container">

    <header class="whyus-head">
      <div class="whyus-kicker">
        <span>{{ 'atw.whyUs.sectionNumber' | transloco }}</span>
        {{ 'atw.whyUs.eyebrow' | transloco }}
      </div>

      <h2>{{ 'atw.whyUs.title' | transloco }}</h2>

      <p>{{ 'atw.whyUs.subtitle' | transloco }}</p>
    </header>

    <div class="whyus-switch" role="tablist">
      <button
        *ngFor="let tab of tabs; trackBy: trackByTab"
        type="button"
        class="whyus-switch-btn"
        [class.active]="activeTab === tab.id"
        [attr.aria-selected]="activeTab === tab.id"
        (click)="setActiveTab(tab.id)"
      >
        <span class="switch-icon">
          <img class="img-m" [src]="tab.iconImg" [alt]="tab.tabTitleKey | transloco" />
        </span>

        <span class="switch-content">
          <strong>{{ tab.tabTitleKey | transloco }}</strong>
          <small>{{ tab.tabTextKey | transloco }}</small>
        </span>
      </button>
    </div>

    <ng-container *ngIf="activeContent as content">
      <article class="whyus-panel" [class.company-mode]="content.id === 'employers'">

        <div class="whyus-main-copy">
          <div class="whyus-badge">
            <span>{{ content.badgeNumberKey | transloco }}</span>
            {{ content.badgeTitleKey | transloco }}
          </div>

          <h3>
            {{ content.titleLine1Key | transloco }}
            <strong>{{ content.titleStrongKey | transloco }}</strong>
            {{ content.titleLine2Key | transloco }}
          </h3>

          <p>
            {{ content.descriptionKey | transloco }}
          </p>

          <div class="whyus-actions">
            <a class="primary-action" [routerLink]="content.primaryRoute">
              {{ content.primaryButtonKey | transloco }}
            </a>

            <a class="secondary-action" [routerLink]="content.secondaryRoute">
              {{ content.secondaryButtonKey | transloco }}
            </a>
          </div>
        </div>

        <div class="whyus-reasons">
          <div
            class="whyus-reason-card"
            *ngFor="let feature of content.features; trackBy: trackByTitle"
          >
            <div class="reason-icon">
              <img class="img-l" [src]="feature.iconImg" [alt]="feature.titleKey | transloco" />
            </div>

            <h4>{{ feature.titleKey | transloco }}</h4>

            <p>{{ feature.textKey | transloco }}</p>
          </div>
        </div>

        <aside class="whyus-side-card">
          <div class="side-card-head">
            <div class="side-card-icon">
              <img class="img-l" [src]="content.iconImg" [alt]="content.visualTitleKey | transloco" />
            </div>

            <div>
              <h4>{{ content.visualTitleKey | transloco }}</h4>
              <p>{{ content.visualTextKey | transloco }}</p>
            </div>
          </div>

          <div class="whyus-process">
            <div
              class="process-row"
              *ngFor="let step of content.steps; trackBy: trackByTitle"
            >
              <span>{{ step.icon }}</span>

              <div>
                <strong>{{ step.titleKey | transloco }}</strong>
                <small>{{ step.textKey | transloco }}</small>
              </div>
            </div>
          </div>

          <div class="whyus-proof">
            <div *ngFor="let stat of content.stats; trackBy: trackByTitle">
              <strong>{{ stat.icon }}</strong>
              <span>{{ stat.titleKey | transloco }}</span>
              <small>{{ stat.textKey | transloco }}</small>
            </div>
          </div>
        </aside>

      </article>
    </ng-container>

  </div>
</section>